<template>
    <v-dialog
        v-model    = "value"
        transition = "dialog-bottom-transition"
        fullscreen
        hide-overlay
        persistent
        no-click-animation
    >
        <div class="white" style="margin-top: 6px;height: calc(100% - 15px); width: calc(100% - 75px); ">
            <f-dialog-title
                title   = "INBOX"
                @cancel = "onClose"
                style="border-radius: 4px;margin-left: 75px; "
            >
            </f-dialog-title>

            <div class="w-100 mt-3">
                <m-inbox
                    :show-title = "false"
                    ref         = "inbox"
                    @close      = "onClose"
                />
            </div>
        </div>
    </v-dialog>
</template>

<script>
import MInbox from "@/modules/inb/components/main/MInbox";
import FDialogTitle from "@/modules/core/components/utils/FDialogTitle";
export default {
    name: "DInbox",

    components: {
        FDialogTitle,
        MInbox,
    },

    props: {
        value: {},
    },

    data: () => ({
        site: null,
        refresh: 0
    }),

    watch: {
        value () {
            if (!this.value) {
                return;
            }

            this.$nextTick(() => {
                this.$refs.inbox.refresh();
                this.$refs.inbox.onReload();
            })
        },
    },

    methods: {
        onClose () {
            this.$emit("input", false);
        },
    }
}

</script>

<style scoped>

</style>